import type { RootState } from '@core/core/store'
import type { UploadedFile } from '@core/core/types'

export const selectUploadedFile = (state: RootState): UploadedFile[] => state.uploads
